import BrandingModel from "../../../../Global/Models/Branding/BrandingModel";
import ImagesModel from "../../../../Global/Models/Images/ImagesModel";
import RelatedEntityRelationship from "../../../../Global/Models/Related/RelatedEntityRelationship";
import { AuthRequirementType } from "../../../../Global/Types/GlobalTypes";
import MiniGamesContext from "../MiniGamesContext";
import EitherOrPointsModel from "./EitherOrPointsModel";

export default class EitherOrBasicModel {
  public id: string = "";
  public title: string = "";
  public alternativeTitle: string = "";
  public description: string = "";
  public images: ImagesModel = new ImagesModel();
  public flags: string[] = [];
  public status: string = "";
  public language: string = "";
  public authRequirement: AuthRequirementType = null;
  public winningCondition: string = "";
  public lives: number = 0;
  public time: number = 0;
  public points: EitherOrPointsModel[] = [];
  public customFields: Record<string, string> = null;
  public branding: BrandingModel = null;
  public labels: Record<string, string> = null;
  public adContent: string = "";
  public context: MiniGamesContext = null;
  public type: string = "";
  public related: RelatedEntityRelationship[] = [];
  public totalParticipationsCount: number = 0;
  public totalUsersCount: number = 0;
  public finishedParticipationsCount: number = 0;
  public averageStartedParticipationsCount: number = 0;
  public averageFinishedParticipationsCount: number = 0;
  public createdAt: string = "";
  public updatedAt: string = "";
}
